import styled from 'styled-components'

export const Back = styled.div`
  font-size: 12px;
  margin: 0 auto;
  margin-top: 10px;
  text-align: center;
`
export const ButtonBack = styled.button`
  display: flex;
  align-items: center;
  svg {
    vertical-align: middle;
  }
`
